import React from "react";
import { HashLink } from "react-router-hash-link";
import {
  IntegrateFMsgContainer,
  StyledSolvingProblemsIlustrationContainer,
  StyledInnerIntegrateFMsg,
} from "../dashboard.style";
import { ReactComponent as SolvingProblems } from "../../../img/SolvingProblems.svg";

const LearnMoreFBIntMsg = () => {
  return (
    <IntegrateFMsgContainer>
      <StyledSolvingProblemsIlustrationContainer>
        <SolvingProblems />
      </StyledSolvingProblemsIlustrationContainer>
      <StyledInnerIntegrateFMsg>
        <h3>Facebook Audiences</h3>
        <p>
          Over the next few weeks we will release an integration to automatically connect Fixel with your Facebook Ads
          account for simple audience management.
        </p>
        <p>
          In the meanwhile you can create Fixel audiences manually in Facebook. <br />
          (it works just as well, pinky swear!)
        </p>
        <HashLink smooth to="/support#Creating_Fixel_audiences_in_Facebook_Ads">
          Learn how
        </HashLink>
      </StyledInnerIntegrateFMsg>
    </IntegrateFMsgContainer>
  );
};
export default LearnMoreFBIntMsg;
